import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";

export default function AdminPatients() {
  const [p, setP] = useState([]);
  useEffect(() => { api.get("/admin/patients").then(r => setP(r.data)); }, []);
  return (
    <div className="space-y-6">
      <div><div className="cm-eyebrow mb-2">Patients</div><h1 className="cm-h2">Patient roster</h1></div>
      <div className="cm-card overflow-x-auto">
        <table className="w-full text-sm">
          <thead className="text-left text-xs uppercase tracking-wider text-[#94a3b8] border-b border-[#e2e8f0]">
            <tr><th className="py-2 pr-4">Name</th><th className="py-2 pr-4">Email</th><th className="py-2 pr-4">Country</th><th className="py-2">Signed up</th></tr>
          </thead>
          <tbody>
            {p.map(u => (
              <tr key={u.id} className="border-b border-[#e2e8f0] last:border-0" data-testid={`admin-patient-${u.id}`}>
                <td className="py-3 pr-4 font-medium text-[#1a2b4a]">{u.first_name} {u.last_name}</td>
                <td className="py-3 pr-4 text-[#475569]">{u.email}</td>
                <td className="py-3 pr-4 text-[#475569]">{u.country || "—"}</td>
                <td className="py-3 text-[#475569] text-xs">{(u.created_at||"").slice(0,10)}</td>
              </tr>
            ))}
            {p.length === 0 && <tr><td className="py-3 text-[#475569]" colSpan="4">No patients yet.</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
